import { render } from "./t-input.vue?vue&type=template&id=72ec8f93"
import script from "./t-input.vue?vue&type=script&lang=js"
export * from "./t-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__